import React from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { UI_OPERATION_STATUS_REQUEST } from '@uncinc/react-drupal-core';
import { nodeGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/Node';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useOperationStatus from '../../../hooks/useOperationStatus';
import useTypedDispatch from '../../../hooks/useTypedDispatch';
import { nodeAnonymize } from '../../../store/actions/Entity/Comment';
import usePopup from '../../../hooks/usePopup';
import DeletePostButtonPopup from './Popup';

import './style.scss';

export interface DeletePostProps {
  postId: number;
}

const DeletePost: React.FC<DeletePostProps> = ({ postId }) => {
  const { t } = useTranslation();
  const dispatch = useTypedDispatch();
  const currentViewPage = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['view', 'forum_post_comments', 'default', 'pager', 'current_page'], 0));
  const currentNodeId = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['entity', 'entityId'], 0));

  const operationStatus = useOperationStatus('node', 'anonymize');

  const popup = usePopup(`DeleteCommentPopup-${postId}`, {
    closeOnOutsideClick: true,
  });

  const onSubmit = async () => {
    try {
      await dispatch(nodeAnonymize(postId, true));
      popup.close();

      dispatch(nodeGet(currentNodeId));
      dispatch(viewGet('forum_post_comments', 'default', currentViewPage, [currentNodeId], {}));
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="DeletePost">
      <button
        type="button"
        className="icon-before icon-trashcan"
        onClick={() => popup.open()}
      >
        {t('common:pages.forum.delete_post.button')}
      </button>

      {popup.isOpen && (
        ReactDOM.createPortal(
          <DeletePostButtonPopup
            isLoading={operationStatus === UI_OPERATION_STATUS_REQUEST}
            onSubmit={onSubmit}
            {...popup.popupProps}
          />,
          document.body,
        )
      )}
    </div>
  );
};

export default DeletePost;
